import "./financeMelaList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import FinanceMelaTable from "../financemelatable/FinanceMelaTable";

const MeetingList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <FinanceMelaTable />
      </div>
    </div>
  );
};

export default MeetingList;
